<template>
  <header class="section-header">
    <div>
      <h2 class="section-header__title">{{ title }}</h2>
      <p v-if="description" class="section-header__description">{{ description }}</p>
    </div>
    <div v-if="$slots.actions" class="section-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  border-bottom: 1px solid var(--border);
  padding-bottom: var(--space-3);
}

.section-header__title {
  margin: 0;
  font-family: var(--font-academic);
  font-size: 1.35rem;
  line-height: 1.2;
}

.section-header__description {
  margin: var(--space-1) 0 0;
  color: var(--ink-muted);
  font-size: 0.9375rem;
}

.section-header__actions {
  display: flex;
  flex: none;
  flex-wrap: wrap;
  gap: var(--space-2);
}

@media (max-width: 767px) {
  .section-header {
    flex-direction: column;
  }
}
</style>
